import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';

import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';

import { RichText } from '@synergycms_core/components/generic/';




//const iscorporate = store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1'

const StandarPoliciesChecks = class StandarPoliciesChecks extends React.Component {
  static displayName = 'StandarPoliciesChecks';
  render() {
    const { config } = this.props;
    const { reservation, classes,isCorporate } = config;

    return (!isCorporate && <>
      <label className={classes.checkBox}>
        <CheckboxField
          defaultValue={reservation.getIn(['customer', 'GDPR_accepted'], false)}
          type={'checkbox'}
          model={'GDPR_accepted'}
          innerStyle={['inputCheck', classes.inputCheck]}
        />
        <RichText
          translate={true}
          ucFirst={true}
          innerStyle={['GDPR_accepted']}
          text={'_%deseo que el hotel y cualquier compañía de su grupo empresarial, me informe de novedades de sus servicios y/o productos%_'}
        />
      </label>
     </>);
  };
};



export default compose(
  
  //withThemeJSS(),
  PropertyManager([
    "classes", "reservation","isCorporate"
  ])
)(StandarPoliciesChecks);
